import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { loginRoutePaths } from '@ebanking/features/login/login.route-paths';
import { Store } from '@ngrx/store';
import {
  initiateRegistration,
  selectRegistration,
  selectRegistrationHasError,
  selectRegistrationIsLoading
} from '@qvs/core/registration';
import { Observable, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { TranslatePipe } from '@ngx-translate/core';
import { InfoBoxComponent } from '~/shared/components/info-box/info-box.component';
import { LoginPageHeaderComponent } from '@ebanking/features/login/login-page-header/login-page-header.component';

@Component({
  selector: 'qvs-registration-form',
  standalone: true,
  imports: [CommonModule, IonicModule, ReactiveFormsModule, TranslatePipe, InfoBoxComponent, LoginPageHeaderComponent],
  templateUrl: './registration-form.component.html',
  styleUrls: ['./registration-form.component.scss']
})
export class RegistrationFormComponent implements OnInit, OnDestroy {
  readonly loginRoutePaths = loginRoutePaths;
  readonly registrationForm = this.formBuilder.group({
    contractnumber: ['', Validators.required],
    initialPassphrase: ['', Validators.required]
  });
  readonly isServerError$: Observable<boolean>;
  readonly isLoading$: Observable<boolean>;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly router: Router,
    private readonly store: Store
  ) {
    this.isServerError$ = this.store.select(selectRegistrationHasError);
    this.isLoading$ = this.store.select(selectRegistrationIsLoading);
  }

  ngOnInit() {
    this.store
      .select(selectRegistration)
      .pipe(
        filter((registration) => !!registration?.statusToken && !!registration?.qrCode?.dataUri),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.router.navigate([this.loginRoutePaths.REGISTRATION_QR]);
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  submit(event: Event) {
    this.completeRegistration(event);
  }

  completeRegistration(event?: Event) {
    event?.preventDefault();
    if (this.registrationForm.valid) {
      const { contractnumber, initialPassphrase } = this.registrationForm.value;
      this.store.dispatch(
        initiateRegistration({
          contractnumber,
          initialPassphrase
        })
      );
    }
  }

  isButtonDisabled() {
    return this.registrationForm.invalid;
  }

  goToLogin() {
    return this.router.navigate([this.loginRoutePaths.LOGIN]);
  }
}
